"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListStyles = exports.listVars = exports.listCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var listCommon = exports.listCommon = _commonProps.defaultCommonProps;
var listVars = exports.listVars = (0, _initVars.default)({
  applied: listCommon
});
var styles = {
  variables: listVars.styles,
  root: {
    "ul&": {
      display: "flex",
      boxSizing: "border-box",
      flexDirection: "column",
      flexWrap: "wrap",
      position: "relative",
      listStyle: "none",
      margin: 0,
      padding: 0,
      outline: 0
    }
  }
};
var useListStyles = exports.useListStyles = (0, _createUseStyles.default)(styles, {
  name: "List"
});